import { EnvironmentBase } from './environmentbase';

const nEnv = new EnvironmentBase();
nEnv.mock = true;
nEnv.production = false;
var dev = true;

nEnv.baseUrl = '';
nEnv.apiUrl = '/Iforms-webforms-app';
nEnv.asgAdminUrl = '/asg-admin';
nEnv.asgSecurityUrl = '/asg-security';
nEnv.asgiOrchUrl = '/asg-iorchestrate';
nEnv.serviceUrl = '/esbservice';
nEnv.iformWebformAPIUrl = '/Iforms-webforms-app';
nEnv.mappingToolAPIUrl = '/Iforms-mappingtool-app';
nEnv.pdf2htmlAPIUrl = '/iforms-pdf2html-app';
nEnv.mlValidationUrl = '/iforms-mlvalidation-app';
nEnv.formsDownloadUrl = '';
nEnv.customModelsAPIUrl = '/transcriber-custom-models-api';


// comment when commiting
// nEnv.apiUrl = 'https://dev-transcriber.acordsolutions.net/Iforms-webforms-app';
// nEnv.baseUrl = 'https://dev-transcriber.acordsolutions.net';
// nEnv.asgAdminUrl ='https://dev-transcriber.acordsolutions.net/asg-admin';
// nEnv.asgSecurityUrl = 'https://dev-transcriber.acordsolutions.net/asg-security';
// nEnv.asgiOrchUrl = 'https://dev-transcriber.acordsolutions.net/asg-iorchestrate';
// nEnv.serviceUrl = '/esbservice';
// nEnv.iformWebformAPIUrl = "https://dev-transcriber.acordsolutions.net/Iforms-webforms-app";
// nEnv.mappingToolAPIUrl = 'https://dev-transcriber.acordsolutions.net/Iforms-mappingtool-app';

export const environment = nEnv;
